import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { defaultValueForFavouriteDeparture, defaultValueForFavouriteTripsForToday } from "../../../../Orchestrator/Recoils/MyAccount";
import { IUserResponse } from "../../../../Orchestrator/Types/Index";
import { IFavoriteDepartureFields, IFavoriteTripsForTodayFields } from "../../../../Orchestrator/Types/Types/OffersResponse";
import { getTranslatedMessage } from "../../../../Lib/Utils/i18n";

interface IUpdatePersonalizeFavoriteDepartureFieldValueParams {
    userData: IUserResponse, listOfStops: any
}

class SetFavoriteDepartureFieldsToAtomAction extends BaseAction<void, IUpdatePersonalizeFavoriteDepartureFieldValueParams> {
    override async run(): Promise<void> {
        try {
            const { userData, listOfStops } = this.params!;
            const favoriteDeparture = userData?.railPreferences?.favoriteDeparture;

            const favoriteDepartureFields = [...defaultValueForFavouriteDeparture].map((field: IFavoriteDepartureFields) => {
                const updatedField = { ...field }
                if (updatedField.name === "from") {
                    updatedField.value = favoriteDeparture?.origin || "";
                    let valueLabel = ""
                    listOfStops.forEach((d: any) => {

                        if (d.id === favoriteDeparture?.origin) {
                            valueLabel = d?.name || ""
                        }
                        if (valueLabel == "" && d?.shuttles?.length > 0) {
                            d.shuttles.forEach((sd: any) => {
                                if (sd.id === favoriteDeparture?.origin) {
                                    valueLabel = sd?.name || ""
                                }
                            })
                        }
                    })
                    updatedField.valueLabel = valueLabel
                } else if (updatedField.name === "to") {
                    updatedField.value = favoriteDeparture?.destination || ""
                    let valueLabel = ""
                    listOfStops.forEach((d: any) => {
                        if (d.id === favoriteDeparture?.destination) {
                            valueLabel = d?.name || ""
                        }
                        if (valueLabel == "" && d?.shuttles?.length > 0) {
                            d.shuttles.forEach((sd: any) => {
                                if (sd.id === favoriteDeparture?.destination) {
                                    valueLabel = sd?.name || ""
                                }
                            })
                        }
                    })
                    updatedField.valueLabel = valueLabel
                } else if (updatedField.name === "outboundDepartureTime") {
                    updatedField.value = favoriteDeparture?.outboundDepartureTime || ""
                    updatedField.valueLabel = updatedField.value
                }
                else if (updatedField.name === "classTicketOption") {
                    updatedField.value = favoriteDeparture?.classType || ""
                    if (favoriteDeparture?.classType?.includes("STANDARD") && favoriteDeparture?.ticketOption === "SFC") {
                        updatedField.valueLabel = getTranslatedMessage("ticketOption.SFC.label", "Standard Flex")
                    } else if (favoriteDeparture?.classType?.includes("STANDARD") && favoriteDeparture?.ticketOption === "SFF") {
                        updatedField.valueLabel = getTranslatedMessage("ticketOption.SFF.label", "Standard Flex Plus")
                    } else if (favoriteDeparture?.classType?.includes("PREMIUM") && favoriteDeparture?.ticketOption === "PFF") {
                        updatedField.valueLabel = getTranslatedMessage("ticketOption.PFF.label", "Premium Flex Plus")
                    }

                }
                return updatedField
            });
            updateRecoilState("favoriteDepartureFieldsAtom", favoriteDepartureFields);
        } catch (error: any) {
            console.log("Error setFavoriteDepartureFieldsToAtom", error?.message);
        }
    }
}

export const setFavoriteDepartureFieldsToAtomAction = new SetFavoriteDepartureFieldsToAtomAction();
